import React, { useState } from 'react';
import { BackgroundDarkColor, useMountEffect } from '@carecircle/core';
import CentredCircularProgress from '../../common/components/CentredCircularProgress';
import { Box } from '@mui/material';

type Props = {
  bgColor?: string;
  showLogoExtended?: boolean;
  noDelay?: boolean;
};

const SHOW_LOADING_INDICATOR_DELAY = 200;

const LoadableFallback = (props: Props) => {
  const [showLoadingIndicator, setShowLoadingIndicator] = useState(false);

  useMountEffect(() => {
    const timerId = window.setTimeout(
      () => setShowLoadingIndicator(true),
      SHOW_LOADING_INDICATOR_DELAY
    );
    return () => {
      clearTimeout(timerId);
    };
  });

  return (
    <Box
      height="100vh"
      bgcolor={props.bgColor ? props.bgColor : BackgroundDarkColor}
    >
      {(props.noDelay || showLoadingIndicator) && (
        <CentredCircularProgress
          centred
          fullScreen
          showLogoExtended={props.showLogoExtended}
        />
      )}
    </Box>
  );
};

export default LoadableFallback;
